import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";

let components: Array<DocumentNumberInput> = [];
const nextSequence = async () => {
  await Promise.allSettled(
    components?.map(async component => {
      await component.nextSequenceGenerate();
    })
  );
};
const deleteComponent = (id: string) => {
  components = components.filter(el => el.uniqId !== id);
};

export { components, nextSequence, deleteComponent };
